export class InventoryCountFilter {
    invCountFilId: number;
    invCountId: number;
    catDetSectionId: number;
    catDetGenderId: number;
    catDetBrandId: number;
    catDetSectionName: string;
    catDetGenderName: string;
    catDetBrandName: string;
}
